import { calculateVinChecksum } from "../utility/calculateVinChecksum";

export function vinRuleChecksum(
  message = "Prüfziffern stimmen nicht überein.",
  isChecksum: number
): (value: any) => boolean | string {
  return value => calculateVinChecksum(value) === +isChecksum || message;
}

export function vinRuleLength(message = "Muss 17 Zeichen lang sein."): (value: any) => boolean | string {
  return value => value.length === 17 || message;
}
